module.exports = __webpack_public_path__ + "static/img/background@2x.552f456.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbTrio/background@2x.png
// module id = 0ZQx
// module chunks = 69